module.exports = "<select class=\"enum mr10 PTit26 f12\" [(ngModel)]=\"value\" (change)=\"handleChange($event)\">\r\n    <option *ngIf=\"selectAll==='true'\" value=\"\">{{'shared.all' | translate}}</option>\r\n    <option *ngFor=\"let item of list\" [value]=\"item.purchaseType\">{{item.purchaseTypeName}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/purchaseType/purchaseType.component.html
// module id = ../../../../../src/app/shared/components/purchaseType/purchaseType.component.html
// module chunks = main